import { useMemo } from "react";
import { CloseTemplateBasis } from "@common/types/closeTemplateBasis";
import { useOrganizationTaskTemplates } from "@api/organizationTaskTemplate.api";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { filterOrgTaskTemplatesForServiceTemplate } from "./orgTaskTemplatePicker.utils";

export function useOrgTaskTemplatesForWorkspace({
    workspaceId,
    basis,
}: {
    workspaceId: string | null;
    basis: CloseTemplateBasis | null;
}) {
    const { closeManagement: isCloseManagementEnabled } = useTypedFlags();
    const { data } = useOrganizationTaskTemplates({
        isEnabled: isCloseManagementEnabled,
    });

    return useMemo(
        () =>
            isCloseManagementEnabled
                ? filterOrgTaskTemplatesForServiceTemplate({
                      templates: data ?? [],
                      workspaceId,
                      basis,
                  })
                : [],
        [data, workspaceId, basis, isCloseManagementEnabled],
    );
}
